import { store } from '@/redux/store'
import axios from 'axios'
import get from 'lodash/get'

export default function makeApi(baseURL) {
  const api = axios.create({
    // if netlify, uncomment line directly below
    // baseURL: '/api',
    // if netlify, comment line directly below
    baseURL,
  })

  api.defaults.headers.post['Content-Type'] = 'application/json'
  api.defaults.headers.put['Content-Type'] = 'application/json'
  api.defaults.headers.delete['Content-Type'] = 'application/json'

  api.interceptors.request.use(
    config => {
      // use the following token to test for token expiry
      // const token =
      //   'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwcmluY2lwYWwiOiJjaHJpc3llbkB0YWl3YW5tb2JpbGUuY29tIiwic3ViIjoiY2hyaXN5ZW5AdGFpd2FubW9iaWxlLmNvbSIsImlzcyI6InR3bXNvY2lhbGVuZ2luZWVyIiwiZXhwIjoxNzA1OTgxNzU3LCJpYXQiOjE3MDU4OTUzNTd9.9Tneg1RtgZAUwjV8bfcaCX8eGQYeel8hLWtLhwi5rv0'

      const token = get(store.getState(), 'auth.token')

      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        }
      }

      return config
    },
    error => Promise.reject(error),
  )

  api.interceptors.response.use(
    response => response, // return data object
    error => {
      // const err = {
      //   message: 'Request failed with status code 401',

      //   name: 'AxiosError',

      //   stack:
      //     'AxiosError: Request failed with status code 401\n    at https://twmsocialengineeringt.com/js/main.0f93dc47.js:2:4074464\n    at XMLHttpRequest.f (https://twmsocialengineeringt.com/js/main.0f93dc47.js:2:4074612)',

      //   config: {
      //     transitional: {
      //       silentJSONParsing: true,

      //       forcedJSONParsing: true,

      //       clarifyTimeoutError: false,
      //     },

      //     adapter: ['xhr', 'http'],

      //     transformRequest: [null],

      //     transformResponse: [null],

      //     timeout: 0,

      //     xsrfCookieName: 'XSRF-TOKEN',

      //     xsrfHeaderName: 'X-XSRF-TOKEN',

      //     maxContentLength: -1,

      //     maxBodyLength: -1,

      //     env: {},

      //     headers: {
      //       Accept: 'application/json, text/plain, */*',

      //       Authorization:
      //         'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwcmluY2lwYWwiOiJib2J6ZW91QHRhaXdhbm1vYmlsZS5jb20iLCJzdWIiOiJib2J6ZW91QHRhaXdhbm1vYmlsZS5jb20iLCJpc3MiOiJ0d21zb2NpYWxlbmdpbmVlciIsImV4cCI6MTczNDUwMjI1MSwiaWF0IjoxNzM0NDE1ODUxfQ.fD6tGA43quHPcahd4S2wyNnknU9rLXsxUmwikqynJdI',
      //     },

      //     // "baseURL": https://twmsocialengineeringt.com/uat,

      //     params: {
      //       sort: null,

      //       pageIndex: 0,

      //       pageSize: 10,

      //       accountId: 43,
      //     },

      //     method: 'get',

      //     url: '/platform/account/manage',
      //   },

      //   code: 'ERR_BAD_REQUEST',

      //   status: 401,
      // }

      console.log('error', error)
      console.log('erroror response', error.response)
      console.log('erroror status', error.status)
      if (error?.response?.status === 401) {
        store.dispatch({ type: 'auth/forceLogout' })
      }
      // if (err.status === 403) {
      //   store.dispatch({ type: 'auth/forbidden' })
      // }

      return error.response || { status: 400 }
    },
  )

  return api
}
